import { render, staticRenderFns } from "./ReviewInfo.vue?vue&type=template&id=0bc41530&scoped=true"
import script from "./ReviewInfo.vue?vue&type=script&lang=js"
export * from "./ReviewInfo.vue?vue&type=script&lang=js"
import style0 from "./ReviewInfo.vue?vue&type=style&index=0&id=0bc41530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc41530",
  null
  
)

export default component.exports